export default "__VITE_ASSET__DxKAUNCy__"